import React, { FC, useRef, useEffect } from 'react';

type ErrorAlertProps = {
    hasError: boolean;
};

const ErrorAlert: FC<ErrorAlertProps> = ({ hasError, children }) => {
    const errorRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (hasError) {
            errorRef.current?.scrollIntoView();
        }
    }, [hasError]);

    return (
        <div ref={errorRef} role="alert" data-testid="auth-error-alert">
            {children}
        </div>
    );
};

export default ErrorAlert;
